import React from "react";

import { format } from "date-fns";

import { Box } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Table from "../../../pages/ServicosAcolhimento/Gestao/Table";
import NaoPossui from "../../../pages/ServicosAcolhimento/Gestao/NaoPossui";
import Information from "../../../pages/ServicosAcolhimento/Visualizar/Information";

export const Gestao = ({ data }) => {
  const hoje = new Date();
  const columnsEntidadeGestora = [
    {
      Header: "Órgão/Entidade Gestora",
      accessor: "nomeEntidade",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Início da Gestão",
      accessor: "dataInicio",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(new Date(props.value), "dd/MM/yyyy") : ""}
          </span>
        );
      },
    },
    {
      Header: "Fim da Gestão",
      accessor: "dataFim",
      Cell: (props) => {
        return (
          <span>
            {props.value &&
            new Date(props.value).setHours(0, 0, 0, 0) >=
              hoje.setHours(0, 0, 0, 0)
              ? format(new Date(props.value), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
  ];

  const columnsSupervisaoExterna = [
    {
      Header: "Supervisor Externo",
      accessor: "nomeEntidade",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Órgão/Entidade do Gestor Externo",
      accessor: "nomeSupervisor",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Início da Supervisão",
      accessor: "dataInicio",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(new Date(props.value), "dd/MM/yyyy") : ""}
          </span>
        );
      },
    },
    {
      Header: "Fim da Supervisão",
      accessor: "dataFim",
      Cell: (props) => {
        return (
          <span>
            {props.value &&
            new Date(props.value).setHours(0, 0, 0, 0) >=
              hoje.setHours(0, 0, 0, 0)
              ? format(new Date(props.value), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
  ];

  const columnsSupervisaoOGMunicipal = [
    {
      Header: "Supervisor do Órgão Gestor Municipal",
      accessor: "nomeSupervisor",
      Cell: (props) => {
        return <span title={props.value}>{props.value}</span>;
      },
    },
    {
      Header: "Início da Supervisão",
      accessor: "dataInicio",
      Cell: (props) => {
        return (
          <span>
            {props.value ? format(new Date(props.value), "dd/MM/yyyy") : ""}
          </span>
        );
      },
    },
    {
      Header: "Fim da Supervisão",
      accessor: "dataFim",
      Cell: (props) => {
        return (
          <span>
            {props.value &&
            new Date(props.value).setHours(0, 0, 0, 0) >=
              hoje.setHours(0, 0, 0, 0)
              ? format(new Date(props.value), "dd/MM/yyyy")
              : ""}
          </span>
        );
      },
    },
  ];

  return data ? (
    <Box display="block">
      {data.servicoAcolhimento?.naturezaServico === "privada" && (
        <Box className="break-page">
          <Group
            bgColor="#DDEBEA"
            title="Estatuto da Entidade"
            mt="15px"
            py="12px"
            mtDivider="5px"
          >
            {data.possuiEstatuto === "S" ? (
              <Information
                title="Última atualização do Estatuto da Entidade:"
                information={
                  data.ultimaAtualizacaoEstatuto
                    ? format(data.ultimaAtualizacaoEstatuto, "dd/MM/yyyy")
                    : ""
                }
                mt="10px"
              />
            ) : (
              <NaoPossui />
            )}
          </Group>
        </Box>
      )}

      <Box className="break-page">
        <Group
          bgColor="#DDEBEA"
          title="Órgão/Entidade Gestora"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          {data.possuiEntidadeGestora === "S" ? (
            data.listaEntidadeGestora ? (
              <Table
                data={data.listaEntidadeGestora}
                columns={columnsEntidadeGestora}
              />
            ) : (
              <NaoPossui />
            )
          ) : (
            <NaoPossui />
          )}
        </Group>
      </Box>

      <Box className="break-page">
        <Group
          bgColor="#DDEBEA"
          title="Supervisão Externa"
          mt="15px"
          py="12px"
          mtDivider="5px"
        >
          {data.possuiSupervisaoExterna === "S" ? (
            data.listaSupervisaoExterna ? (
              <Table
                data={data.listaSupervisaoExterna}
                columns={columnsSupervisaoExterna}
                entidade={"supervisaoExterna"}
              />
            ) : (
              <NaoPossui />
            )
          ) : (
            <NaoPossui />
          )}
        </Group>
      </Box>

      <Box className="break-page">
        <Group
          bgColor="#DDEBEA"
          title="Supervisão do Órgão Gestor Municipal"
          mt="15px"
          py="12px"
          mtDivider="5px"
          className="break-page"
        >
          {data.possuiSupervisaoOGMunicipal === "S" ? (
            data.listaSupervisaoOrgaoGestor ? (
              <Table
                data={data.listaSupervisaoOrgaoGestor}
                columns={columnsSupervisaoOGMunicipal}
                entidade={"supervisaoGestor"}
              />
            ) : (
              <NaoPossui />
            )
          ) : (
            <NaoPossui />
          )}
        </Group>
      </Box>
    </Box>
  ) : (
    <Box display="block">
      <Group
        bgColor="#DDEBEA"
        title="Gestão"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
